import $ from 'jquery';

import 'picturefill';
import cookieConsent from './cookieConsent';
import videolink from './videolink';
import { navToggle } from './headerActions';
import Animated from './animated';
import contactForm from './contactForm';
import { partnersList } from './partnersList';
import initChart from './chart';
import renderGoogleMap from './renderGoogleMap';
import GeneralMeeting from './generalMeeting';
import counterMixer from './counters';

import initSliders from '../../../vendor/jamel/slider-bundle/Resources/ui/js/_initSliders';
import initFullscreen from '../../../vendor/jamel/slider-bundle/Resources/ui/js/_initFullscreen';
import '../../../vendor/jamel/images-lazy-load-bundle/Resources/public/js/images-lazy-load-bundle.min';
import {popup} from "./popup";

window.initMap = renderGoogleMap;

document.addEventListener('DOMContentLoaded', () => {
    cookieConsent();
    videolink();

    // header menu
    navToggle($('.burger-menu'));

    // contact form
    contactForm();
    counterMixer();
    // chart js
    initChart($('.chart'));

    // jamel-slider-bundle
    initSliders();
    initFullscreen();
    // checkParent();

    const animatedElements = new Animated($('.animate'));
    animatedElements.init();

    const clickToggler = new GeneralMeeting();
    clickToggler.init();

    partnersList($('.partners-list__item'));

    popup($('.popup-pp'));
});
